/**
 * @module:  文本行内空白组件
 * @author: Liang Huang
 * @date: 2019-10-17 14:00:09
 */
import React from 'react';
import PropTypes from 'prop-types'; //   {
//   width?: number;
//   // 填充文本
//   text?: string;
//   className?: string;
// }

var Space = function Space(props) {
  var pWidth = typeof props.width === 'number' ? props.width : 8;
  var txt = props.text || '|';
  var className = props.className || '';
  return (
    /*#__PURE__*/
    React.createElement("span", {
      style: {
        paddingLeft: "".concat(pWidth, "px"),
        paddingRight: "".concat(pWidth, "px")
      },
      className: className
    }, txt)
  );
};

Space.propTypes = {
  width: PropTypes.number,
  text: PropTypes.node,
  className: PropTypes.string
};
export default Space;